const Ge = (e, t) => e === t, A = Symbol("solid-proxy"), xe = typeof Proxy == "function", pe = Symbol("solid-track"), B = {
  equals: Ge
};
let Ve = Ze;
const O = 1, H = 2, $e = {
  owned: null,
  cleanups: null,
  context: null,
  owner: null
};
var b = null;
let ne = null, qe = null, w = null, $ = null, Z = null, J = 0;
function We(e, t) {
  const n = w, r = b, l = e.length === 0, i = t === void 0 ? r : t, o = l ? $e : {
    owned: null,
    cleanups: null,
    context: i ? i.context : null,
    owner: i
  }, s = l ? e : () => e(() => N(() => I(o)));
  b = o, w = null;
  try {
    return j(s, !0);
  } finally {
    w = n, b = r;
  }
}
function Q(e, t) {
  t = t ? Object.assign({}, B, t) : B;
  const n = {
    value: e,
    observers: null,
    observerSlots: null,
    comparator: t.equals || void 0
  }, r = (l) => (typeof l == "function" && (l = l(n.value)), Se(n, l));
  return [ke.bind(n), r];
}
function m(e, t, n) {
  const r = Ae(e, t, !1, O);
  ee(r);
}
function oe(e, t, n) {
  n = n ? Object.assign({}, B, n) : B;
  const r = Ae(e, t, !0, 0);
  return r.observers = null, r.observerSlots = null, r.comparator = n.equals || void 0, ee(r), ke.bind(r);
}
function Ye(e) {
  return j(e, !1);
}
function N(e) {
  if (w === null) return e();
  const t = w;
  w = null;
  try {
    return e();
  } finally {
    w = t;
  }
}
function Je(e) {
  return b === null || (b.cleanups === null ? b.cleanups = [e] : b.cleanups.push(e)), e;
}
function ce() {
  return w;
}
function _e(e, t) {
  const n = Symbol("context");
  return {
    id: n,
    Provider: rt(n),
    defaultValue: e
  };
}
function Me(e) {
  let t;
  return b && b.context && (t = b.context[e.id]) !== void 0 ? t : e.defaultValue;
}
function Qe(e) {
  const t = oe(e), n = oe(() => ae(t()));
  return n.toArray = () => {
    const r = n();
    return Array.isArray(r) ? r : r != null ? [r] : [];
  }, n;
}
function ke() {
  if (this.sources && this.state)
    if (this.state === O) ee(this);
    else {
      const e = $;
      $ = null, j(() => G(this), !1), $ = e;
    }
  if (w) {
    const e = this.observers ? this.observers.length : 0;
    w.sources ? (w.sources.push(this), w.sourceSlots.push(e)) : (w.sources = [this], w.sourceSlots = [e]), this.observers ? (this.observers.push(w), this.observerSlots.push(w.sources.length - 1)) : (this.observers = [w], this.observerSlots = [w.sources.length - 1]);
  }
  return this.value;
}
function Se(e, t, n) {
  let r = e.value;
  return (!e.comparator || !e.comparator(r, t)) && (e.value = t, e.observers && e.observers.length && j(() => {
    for (let l = 0; l < e.observers.length; l += 1) {
      const i = e.observers[l], o = ne && ne.running;
      o && ne.disposed.has(i), (o ? !i.tState : !i.state) && (i.pure ? $.push(i) : Z.push(i), i.observers && Oe(i)), o || (i.state = O);
    }
    if ($.length > 1e6)
      throw $ = [], new Error();
  }, !1)), t;
}
function ee(e) {
  if (!e.fn) return;
  I(e);
  const t = J;
  et(
    e,
    e.value,
    t
  );
}
function et(e, t, n) {
  let r;
  const l = b, i = w;
  w = b = e;
  try {
    r = e.fn(t);
  } catch (o) {
    return e.pure && (e.state = O, e.owned && e.owned.forEach(I), e.owned = null), e.updatedAt = n + 1, Pe(o);
  } finally {
    w = i, b = l;
  }
  (!e.updatedAt || e.updatedAt <= n) && (e.updatedAt != null && "observers" in e ? Se(e, r) : e.value = r, e.updatedAt = n);
}
function Ae(e, t, n, r = O, l) {
  const i = {
    fn: e,
    state: r,
    updatedAt: null,
    owned: null,
    sources: null,
    sourceSlots: null,
    cleanups: null,
    value: t,
    owner: b,
    context: b ? b.context : null,
    pure: n
  };
  return b === null || b !== $e && (b.owned ? b.owned.push(i) : b.owned = [i]), i;
}
function Ce(e) {
  if (e.state === 0) return;
  if (e.state === H) return G(e);
  if (e.suspense && N(e.suspense.inFallback)) return e.suspense.effects.push(e);
  const t = [e];
  for (; (e = e.owner) && (!e.updatedAt || e.updatedAt < J); )
    e.state && t.push(e);
  for (let n = t.length - 1; n >= 0; n--)
    if (e = t[n], e.state === O)
      ee(e);
    else if (e.state === H) {
      const r = $;
      $ = null, j(() => G(e, t[0]), !1), $ = r;
    }
}
function j(e, t) {
  if ($) return e();
  let n = !1;
  t || ($ = []), Z ? n = !0 : Z = [], J++;
  try {
    const r = e();
    return tt(n), r;
  } catch (r) {
    n || (Z = null), $ = null, Pe(r);
  }
}
function tt(e) {
  if ($ && (Ze($), $ = null), e) return;
  const t = Z;
  Z = null, t.length && j(() => Ve(t), !1);
}
function Ze(e) {
  for (let t = 0; t < e.length; t++) Ce(e[t]);
}
function G(e, t) {
  e.state = 0;
  for (let n = 0; n < e.sources.length; n += 1) {
    const r = e.sources[n];
    if (r.sources) {
      const l = r.state;
      l === O ? r !== t && (!r.updatedAt || r.updatedAt < J) && Ce(r) : l === H && G(r, t);
    }
  }
}
function Oe(e) {
  for (let t = 0; t < e.observers.length; t += 1) {
    const n = e.observers[t];
    n.state || (n.state = H, n.pure ? $.push(n) : Z.push(n), n.observers && Oe(n));
  }
}
function I(e) {
  let t;
  if (e.sources)
    for (; e.sources.length; ) {
      const n = e.sources.pop(), r = e.sourceSlots.pop(), l = n.observers;
      if (l && l.length) {
        const i = l.pop(), o = n.observerSlots.pop();
        r < l.length && (i.sourceSlots[o] = r, l[r] = i, n.observerSlots[r] = o);
      }
    }
  if (e.tOwned) {
    for (t = e.tOwned.length - 1; t >= 0; t--) I(e.tOwned[t]);
    delete e.tOwned;
  }
  if (e.owned) {
    for (t = e.owned.length - 1; t >= 0; t--) I(e.owned[t]);
    e.owned = null;
  }
  if (e.cleanups) {
    for (t = e.cleanups.length - 1; t >= 0; t--) e.cleanups[t]();
    e.cleanups = null;
  }
  e.state = 0;
}
function nt(e) {
  return e instanceof Error ? e : new Error(typeof e == "string" ? e : "Unknown error", {
    cause: e
  });
}
function Pe(e, t = b) {
  throw nt(e);
}
function ae(e) {
  if (typeof e == "function" && !e.length) return ae(e());
  if (Array.isArray(e)) {
    const t = [];
    for (let n = 0; n < e.length; n++) {
      const r = ae(e[n]);
      Array.isArray(r) ? t.push.apply(t, r) : t.push(r);
    }
    return t;
  }
  return e;
}
function rt(e, t) {
  return function(r) {
    let l;
    return m(
      () => l = N(() => (b.context = {
        ...b.context,
        [e]: r.value
      }, Qe(() => r.children))),
      void 0
    ), l;
  };
}
function p(e, t) {
  return N(() => e(t || {}));
}
function K() {
  return !0;
}
const ue = {
  get(e, t, n) {
    return t === A ? n : e.get(t);
  },
  has(e, t) {
    return t === A ? !0 : e.has(t);
  },
  set: K,
  deleteProperty: K,
  getOwnPropertyDescriptor(e, t) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(t);
      },
      set: K,
      deleteProperty: K
    };
  },
  ownKeys(e) {
    return e.keys();
  }
};
function re(e) {
  return (e = typeof e == "function" ? e() : e) ? e : {};
}
function lt() {
  for (let e = 0, t = this.length; e < t; ++e) {
    const n = this[e]();
    if (n !== void 0) return n;
  }
}
function it(...e) {
  let t = !1;
  for (let o = 0; o < e.length; o++) {
    const s = e[o];
    t = t || !!s && A in s, e[o] = typeof s == "function" ? (t = !0, oe(s)) : s;
  }
  if (xe && t)
    return new Proxy(
      {
        get(o) {
          for (let s = e.length - 1; s >= 0; s--) {
            const c = re(e[s])[o];
            if (c !== void 0) return c;
          }
        },
        has(o) {
          for (let s = e.length - 1; s >= 0; s--)
            if (o in re(e[s])) return !0;
          return !1;
        },
        keys() {
          const o = [];
          for (let s = 0; s < e.length; s++)
            o.push(...Object.keys(re(e[s])));
          return [...new Set(o)];
        }
      },
      ue
    );
  const n = {}, r = /* @__PURE__ */ Object.create(null);
  for (let o = e.length - 1; o >= 0; o--) {
    const s = e[o];
    if (!s) continue;
    const c = Object.getOwnPropertyNames(s);
    for (let a = c.length - 1; a >= 0; a--) {
      const f = c[a];
      if (f === "__proto__" || f === "constructor") continue;
      const h = Object.getOwnPropertyDescriptor(s, f);
      if (!r[f])
        r[f] = h.get ? {
          enumerable: !0,
          configurable: !0,
          get: lt.bind(n[f] = [h.get.bind(s)])
        } : h.value !== void 0 ? h : void 0;
      else {
        const d = n[f];
        d && (h.get ? d.push(h.get.bind(s)) : h.value !== void 0 && d.push(() => h.value));
      }
    }
  }
  const l = {}, i = Object.keys(r);
  for (let o = i.length - 1; o >= 0; o--) {
    const s = i[o], c = r[s];
    c && c.get ? Object.defineProperty(l, s, c) : l[s] = c ? c.value : void 0;
  }
  return l;
}
function de(e, ...t) {
  if (xe && A in e) {
    const l = new Set(t.length > 1 ? t.flat() : t[0]), i = t.map((o) => new Proxy(
      {
        get(s) {
          return o.includes(s) ? e[s] : void 0;
        },
        has(s) {
          return o.includes(s) && s in e;
        },
        keys() {
          return o.filter((s) => s in e);
        }
      },
      ue
    ));
    return i.push(
      new Proxy(
        {
          get(o) {
            return l.has(o) ? void 0 : e[o];
          },
          has(o) {
            return l.has(o) ? !1 : o in e;
          },
          keys() {
            return Object.keys(e).filter((o) => !l.has(o));
          }
        },
        ue
      )
    ), i;
  }
  const n = {}, r = t.map(() => ({}));
  for (const l of Object.getOwnPropertyNames(e)) {
    const i = Object.getOwnPropertyDescriptor(e, l), o = !i.get && !i.set && i.enumerable && i.writable && i.configurable;
    let s = !1, c = 0;
    for (const a of t)
      a.includes(l) && (s = !0, o ? r[c][l] = i.value : Object.defineProperty(r[c], l, i)), ++c;
    s || (o ? n[l] = i.value : Object.defineProperty(n, l, i));
  }
  return [...r, n];
}
let st = 0;
function k() {
  return `cl-${st++}`;
}
const ot = [
  "allowfullscreen",
  "async",
  "autofocus",
  "autoplay",
  "checked",
  "controls",
  "default",
  "disabled",
  "formnovalidate",
  "hidden",
  "indeterminate",
  "inert",
  "ismap",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "seamless",
  "selected"
], ct = /* @__PURE__ */ new Set([
  "className",
  "value",
  "readOnly",
  "formNoValidate",
  "isMap",
  "noModule",
  "playsInline",
  ...ot
]), at = /* @__PURE__ */ new Set([
  "innerHTML",
  "textContent",
  "innerText",
  "children"
]), ut = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  className: "class",
  htmlFor: "for"
}), ft = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  class: "className",
  formnovalidate: {
    $: "formNoValidate",
    BUTTON: 1,
    INPUT: 1
  },
  ismap: {
    $: "isMap",
    IMG: 1
  },
  nomodule: {
    $: "noModule",
    SCRIPT: 1
  },
  playsinline: {
    $: "playsInline",
    VIDEO: 1
  },
  readonly: {
    $: "readOnly",
    INPUT: 1,
    TEXTAREA: 1
  }
});
function ht(e, t) {
  const n = ft[e];
  return typeof n == "object" ? n[t] ? n.$ : void 0 : n;
}
const dt = /* @__PURE__ */ new Set([
  "beforeinput",
  "click",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
]), gt = {
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace"
};
function pt(e, t, n) {
  let r = n.length, l = t.length, i = r, o = 0, s = 0, c = t[l - 1].nextSibling, a = null;
  for (; o < l || s < i; ) {
    if (t[o] === n[s]) {
      o++, s++;
      continue;
    }
    for (; t[l - 1] === n[i - 1]; )
      l--, i--;
    if (l === o) {
      const f = i < r ? s ? n[s - 1].nextSibling : n[i - s] : c;
      for (; s < i; ) e.insertBefore(n[s++], f);
    } else if (i === s)
      for (; o < l; )
        (!a || !a.has(t[o])) && t[o].remove(), o++;
    else if (t[o] === n[i - 1] && n[s] === t[l - 1]) {
      const f = t[--l].nextSibling;
      e.insertBefore(n[s++], t[o++].nextSibling), e.insertBefore(n[--i], f), t[l] = n[i];
    } else {
      if (!a) {
        a = /* @__PURE__ */ new Map();
        let h = s;
        for (; h < i; ) a.set(n[h], h++);
      }
      const f = a.get(t[o]);
      if (f != null)
        if (s < f && f < i) {
          let h = o, d = 1, v;
          for (; ++h < l && h < i && !((v = a.get(t[h])) == null || v !== f + d); )
            d++;
          if (d > f - s) {
            const x = t[o];
            for (; s < f; ) e.insertBefore(n[s++], x);
          } else e.replaceChild(n[s++], t[o++]);
        } else o++;
      else t[o++].remove();
    }
  }
}
const ve = "_$DX_DELEGATE";
function y(e, t, n, r) {
  let l;
  const i = () => {
    const s = r ? document.createElementNS("http://www.w3.org/1998/Math/MathML", "template") : document.createElement("template");
    return s.innerHTML = e, n ? s.content.firstChild.firstChild : r ? s.firstChild : s.content.firstChild;
  }, o = t ? () => N(() => document.importNode(l || (l = i()), !0)) : () => (l || (l = i())).cloneNode(!0);
  return o.cloneNode = o, o;
}
function Ee(e, t = window.document) {
  const n = t[ve] || (t[ve] = /* @__PURE__ */ new Set());
  for (let r = 0, l = e.length; r < l; r++) {
    const i = e[r];
    n.has(i) || (n.add(i), t.addEventListener(i, _t));
  }
}
function u(e, t, n) {
  n == null ? e.removeAttribute(t) : e.setAttribute(t, n);
}
function vt(e, t, n, r) {
  r == null ? e.removeAttributeNS(t, n) : e.setAttributeNS(t, n, r);
}
function bt(e, t, n) {
  n ? e.setAttribute(t, "") : e.removeAttribute(t);
}
function yt(e, t) {
  t == null ? e.removeAttribute("class") : e.className = t;
}
function Te(e, t, n, r) {
  if (r)
    Array.isArray(n) ? (e[`$$${t}`] = n[0], e[`$$${t}Data`] = n[1]) : e[`$$${t}`] = n;
  else if (Array.isArray(n)) {
    const l = n[0];
    e.addEventListener(t, n[0] = (i) => l.call(e, n[1], i));
  } else e.addEventListener(t, n, typeof n != "function" && n);
}
function wt(e, t, n = {}) {
  const r = Object.keys(t || {}), l = Object.keys(n);
  let i, o;
  for (i = 0, o = l.length; i < o; i++) {
    const s = l[i];
    !s || s === "undefined" || t[s] || (be(e, s, !1), delete n[s]);
  }
  for (i = 0, o = r.length; i < o; i++) {
    const s = r[i], c = !!t[s];
    !s || s === "undefined" || n[s] === c || !c || (be(e, s, !0), n[s] = c);
  }
  return n;
}
function mt(e, t, n) {
  if (!t) return n ? u(e, "style") : t;
  const r = e.style;
  if (typeof t == "string") return r.cssText = t;
  typeof n == "string" && (r.cssText = n = void 0), n || (n = {}), t || (t = {});
  let l, i;
  for (i in n)
    t[i] == null && r.removeProperty(i), delete n[i];
  for (i in t)
    l = t[i], l !== n[i] && (r.setProperty(i, l), n[i] = l);
  return n;
}
function U(e, t = {}, n, r) {
  const l = {};
  return r || m(
    () => l.children = R(e, t.children, l.children)
  ), m(() => typeof t.ref == "function" && ge(t.ref, e)), m(() => xt(e, t, n, !0, l, !0)), l;
}
function ge(e, t, n) {
  return N(() => e(t, n));
}
function g(e, t, n, r) {
  if (n !== void 0 && !r && (r = []), typeof t != "function") return R(e, t, r, n);
  m((l) => R(e, t(), l, n), r);
}
function xt(e, t, n, r, l = {}, i = !1) {
  t || (t = {});
  for (const o in l)
    if (!(o in t)) {
      if (o === "children") continue;
      l[o] = ye(e, o, null, l[o], n, i, t);
    }
  for (const o in t) {
    if (o === "children")
      continue;
    const s = t[o];
    l[o] = ye(e, o, s, l[o], n, i, t);
  }
}
function $t(e) {
  return e.toLowerCase().replace(/-([a-z])/g, (t, n) => n.toUpperCase());
}
function be(e, t, n) {
  const r = t.trim().split(/\s+/);
  for (let l = 0, i = r.length; l < i; l++)
    e.classList.toggle(r[l], n);
}
function ye(e, t, n, r, l, i, o) {
  let s, c, a, f, h;
  if (t === "style") return mt(e, n, r);
  if (t === "classList") return wt(e, n, r);
  if (n === r) return r;
  if (t === "ref")
    i || n(e);
  else if (t.slice(0, 3) === "on:") {
    const d = t.slice(3);
    r && e.removeEventListener(d, r, typeof r != "function" && r), n && e.addEventListener(d, n, typeof n != "function" && n);
  } else if (t.slice(0, 10) === "oncapture:") {
    const d = t.slice(10);
    r && e.removeEventListener(d, r, !0), n && e.addEventListener(d, n, !0);
  } else if (t.slice(0, 2) === "on") {
    const d = t.slice(2).toLowerCase(), v = dt.has(d);
    if (!v && r) {
      const x = Array.isArray(r) ? r[0] : r;
      e.removeEventListener(d, x);
    }
    (v || n) && (Te(e, d, n, v), v && Ee([d]));
  } else if (t.slice(0, 5) === "attr:")
    u(e, t.slice(5), n);
  else if (t.slice(0, 5) === "bool:")
    bt(e, t.slice(5), n);
  else if ((h = t.slice(0, 5) === "prop:") || (a = at.has(t)) || !l && ((f = ht(t, e.tagName)) || (c = ct.has(t))) || (s = e.nodeName.includes("-") || "is" in o))
    h && (t = t.slice(5), c = !0), t === "class" || t === "className" ? yt(e, n) : s && !c && !a ? e[$t(t)] = n : e[f || t] = n;
  else {
    const d = l && t.indexOf(":") > -1 && gt[t.split(":")[0]];
    d ? vt(e, d, t, n) : u(e, ut[t] || t, n);
  }
  return n;
}
function _t(e) {
  let t = e.target;
  const n = `$$${e.type}`, r = e.target, l = e.currentTarget, i = (c) => Object.defineProperty(e, "target", {
    configurable: !0,
    value: c
  }), o = () => {
    const c = t[n];
    if (c && !t.disabled) {
      const a = t[`${n}Data`];
      if (a !== void 0 ? c.call(t, a, e) : c.call(t, e), e.cancelBubble) return;
    }
    return t.host && typeof t.host != "string" && !t.host._$host && t.contains(e.target) && i(t.host), !0;
  }, s = () => {
    for (; o() && (t = t._$host || t.parentNode || t.host); ) ;
  };
  if (Object.defineProperty(e, "currentTarget", {
    configurable: !0,
    get() {
      return t || document;
    }
  }), e.composedPath) {
    const c = e.composedPath();
    i(c[0]);
    for (let a = 0; a < c.length - 2 && (t = c[a], !!o()); a++) {
      if (t._$host) {
        t = t._$host, s();
        break;
      }
      if (t.parentNode === l)
        break;
    }
  } else s();
  i(r);
}
function R(e, t, n, r, l) {
  for (; typeof n == "function"; ) n = n();
  if (t === n) return n;
  const i = typeof t, o = r !== void 0;
  if (e = o && n[0] && n[0].parentNode || e, i === "string" || i === "number") {
    if (i === "number" && (t = t.toString(), t === n))
      return n;
    if (o) {
      let s = n[0];
      s && s.nodeType === 3 ? s.data !== t && (s.data = t) : s = document.createTextNode(t), n = P(e, n, r, s);
    } else
      n !== "" && typeof n == "string" ? n = e.firstChild.data = t : n = e.textContent = t;
  } else if (t == null || i === "boolean")
    n = P(e, n, r);
  else {
    if (i === "function")
      return m(() => {
        let s = t();
        for (; typeof s == "function"; ) s = s();
        n = R(e, s, n, r);
      }), () => n;
    if (Array.isArray(t)) {
      const s = [], c = n && Array.isArray(n);
      if (fe(s, t, n, l))
        return m(() => n = R(e, s, n, r, !0)), () => n;
      if (s.length === 0) {
        if (n = P(e, n, r), o) return n;
      } else c ? n.length === 0 ? we(e, s, r) : pt(e, n, s) : (n && P(e), we(e, s));
      n = s;
    } else if (t.nodeType) {
      if (Array.isArray(n)) {
        if (o) return n = P(e, n, r, t);
        P(e, n, null, t);
      } else n == null || n === "" || !e.firstChild ? e.appendChild(t) : e.replaceChild(t, e.firstChild);
      n = t;
    }
  }
  return n;
}
function fe(e, t, n, r) {
  let l = !1;
  for (let i = 0, o = t.length; i < o; i++) {
    let s = t[i], c = n && n[e.length], a;
    if (!(s == null || s === !0 || s === !1)) if ((a = typeof s) == "object" && s.nodeType)
      e.push(s);
    else if (Array.isArray(s))
      l = fe(e, s, c) || l;
    else if (a === "function")
      if (r) {
        for (; typeof s == "function"; ) s = s();
        l = fe(
          e,
          Array.isArray(s) ? s : [s],
          Array.isArray(c) ? c : [c]
        ) || l;
      } else
        e.push(s), l = !0;
    else {
      const f = String(s);
      c && c.nodeType === 3 && c.data === f ? e.push(c) : e.push(document.createTextNode(f));
    }
  }
  return l;
}
function we(e, t, n = null) {
  for (let r = 0, l = t.length; r < l; r++) e.insertBefore(t[r], n);
}
function P(e, t, n, r) {
  if (n === void 0) return e.textContent = "";
  const l = r || document.createTextNode("");
  if (t.length) {
    let i = !1;
    for (let o = t.length - 1; o >= 0; o--) {
      const s = t[o];
      if (l !== s) {
        const c = s.parentNode === e;
        !i && !o ? c ? e.replaceChild(l, s) : e.insertBefore(l, n) : c && s.remove();
      } else i = !0;
    }
  } else e.insertBefore(l, n);
  return [l];
}
function Mt(e) {
  return Object.keys(e).reduce((n, r) => {
    const l = e[r];
    return n[r] = Object.assign({}, l), je(l.value) && !Zt(l.value) && !Array.isArray(l.value) && (n[r].value = Object.assign({}, l.value)), Array.isArray(l.value) && (n[r].value = l.value.slice(0)), n;
  }, {});
}
function kt(e) {
  return e ? Object.keys(e).reduce((n, r) => {
    const l = e[r];
    return n[r] = je(l) && "value" in l ? l : {
      value: l
    }, n[r].attribute || (n[r].attribute = Ct(r)), n[r].parse = "parse" in n[r] ? n[r].parse : typeof n[r].value != "string", n;
  }, {}) : {};
}
function St(e) {
  return Object.keys(e).reduce((n, r) => (n[r] = e[r].value, n), {});
}
function At(e, t) {
  const n = Mt(t);
  return Object.keys(t).forEach((l) => {
    const i = n[l], o = e.getAttribute(i.attribute), s = e[l];
    o != null && (i.value = i.parse ? Ne(o) : o), s != null && (i.value = Array.isArray(s) ? s.slice(0) : s), i.reflect && me(e, i.attribute, i.value, !!i.parse), Object.defineProperty(e, l, {
      get() {
        return i.value;
      },
      set(c) {
        const a = i.value;
        i.value = c, i.reflect && me(this, i.attribute, i.value, !!i.parse);
        for (let f = 0, h = this.__propertyChangedCallbacks.length; f < h; f++)
          this.__propertyChangedCallbacks[f](l, c, a);
      },
      enumerable: !0,
      configurable: !0
    });
  }), n;
}
function Ne(e) {
  if (e)
    try {
      return JSON.parse(e);
    } catch {
      return e;
    }
}
function me(e, t, n, r) {
  if (n == null || n === !1) return e.removeAttribute(t);
  let l = r ? JSON.stringify(n) : n;
  e.__updating[t] = !0, l === "true" && (l = ""), e.setAttribute(t, l), Promise.resolve().then(() => delete e.__updating[t]);
}
function Ct(e) {
  return e.replace(/\.?([A-Z]+)/g, (t, n) => "-" + n.toLowerCase()).replace("_", "-").replace(/^-/, "");
}
function je(e) {
  return e != null && (typeof e == "object" || typeof e == "function");
}
function Zt(e) {
  return Object.prototype.toString.call(e) === "[object Function]";
}
function Ot(e) {
  return typeof e == "function" && e.toString().indexOf("class") === 0;
}
let le;
function Pt(e, t) {
  const n = Object.keys(t);
  return class extends e {
    static get observedAttributes() {
      return n.map((l) => t[l].attribute);
    }
    constructor() {
      super(), this.__initialized = !1, this.__released = !1, this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = {};
    }
    connectedCallback() {
      if (this.__initialized) return;
      this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = At(this, t);
      const l = St(this.props), i = this.Component, o = le;
      try {
        le = this, this.__initialized = !0, Ot(i) ? new i(l, {
          element: this
        }) : i(l, {
          element: this
        });
      } finally {
        le = o;
      }
    }
    async disconnectedCallback() {
      if (await Promise.resolve(), this.isConnected) return;
      this.__propertyChangedCallbacks.length = 0;
      let l = null;
      for (; l = this.__releaseCallbacks.pop(); ) l(this);
      delete this.__initialized, this.__released = !0;
    }
    attributeChangedCallback(l, i, o) {
      if (this.__initialized && !this.__updating[l] && (l = this.lookupProp(l), l in t)) {
        if (o == null && !this[l]) return;
        this[l] = t[l].parse ? Ne(o) : o;
      }
    }
    lookupProp(l) {
      if (t)
        return n.find((i) => l === i || l === t[i].attribute);
    }
    get renderRoot() {
      return this.shadowRoot || this.attachShadow({
        mode: "open"
      });
    }
    addReleaseCallback(l) {
      this.__releaseCallbacks.push(l);
    }
    addPropertyChangedCallback(l) {
      this.__propertyChangedCallbacks.push(l);
    }
  };
}
function Et(e, t = {}, n = {}) {
  const {
    BaseElement: r = HTMLElement,
    extension: l,
    customElements: i = window.customElements
  } = n;
  return (o) => {
    let s = i.get(e);
    return s ? (s.prototype.Component = o, s) : (s = Pt(r, kt(t)), s.prototype.Component = o, s.prototype.registeredTag = e, i.define(e, s, l), s);
  };
}
function Tt(e) {
  const t = Object.keys(e), n = {};
  for (let r = 0; r < t.length; r++) {
    const [l, i] = Q(e[t[r]]);
    Object.defineProperty(n, t[r], {
      get: l,
      set(o) {
        i(() => o);
      }
    });
  }
  return n;
}
function Nt(e) {
  if (e.assignedSlot && e.assignedSlot._$owner) return e.assignedSlot._$owner;
  let t = e.parentNode;
  for (; t && !t._$owner && !(t.assignedSlot && t.assignedSlot._$owner); )
    t = t.parentNode;
  return t && t.assignedSlot ? t.assignedSlot._$owner : e._$owner;
}
function jt(e) {
  return (t, n) => {
    const { element: r } = n;
    return We((l) => {
      const i = Tt(t);
      r.addPropertyChangedCallback((s, c) => i[s] = c), r.addReleaseCallback(() => {
        r.renderRoot.textContent = "", l();
      });
      const o = e(i, n);
      return g(r.renderRoot, o);
    }, Nt(r));
  };
}
function Dt(e, t, n) {
  return arguments.length === 2 && (n = t, t = {}), Et(e, t)(jt(n));
}
const he = Symbol("store-raw"), E = Symbol("store-node"), C = Symbol("store-has"), De = Symbol("store-self");
function Le(e) {
  let t = e[A];
  if (!t && (Object.defineProperty(e, A, {
    value: t = new Proxy(e, Rt)
  }), !Array.isArray(e))) {
    const n = Object.keys(e), r = Object.getOwnPropertyDescriptors(e);
    for (let l = 0, i = n.length; l < i; l++) {
      const o = n[l];
      r[o].get && Object.defineProperty(e, o, {
        enumerable: r[o].enumerable,
        get: r[o].get.bind(t)
      });
    }
  }
  return t;
}
function V(e) {
  let t;
  return e != null && typeof e == "object" && (e[A] || !(t = Object.getPrototypeOf(e)) || t === Object.prototype || Array.isArray(e));
}
function T(e, t = /* @__PURE__ */ new Set()) {
  let n, r, l, i;
  if (n = e != null && e[he]) return n;
  if (!V(e) || t.has(e)) return e;
  if (Array.isArray(e)) {
    Object.isFrozen(e) ? e = e.slice(0) : t.add(e);
    for (let o = 0, s = e.length; o < s; o++)
      l = e[o], (r = T(l, t)) !== l && (e[o] = r);
  } else {
    Object.isFrozen(e) ? e = Object.assign({}, e) : t.add(e);
    const o = Object.keys(e), s = Object.getOwnPropertyDescriptors(e);
    for (let c = 0, a = o.length; c < a; c++)
      i = o[c], !s[i].get && (l = e[i], (r = T(l, t)) !== l && (e[i] = r));
  }
  return e;
}
function q(e, t) {
  let n = e[t];
  return n || Object.defineProperty(e, t, {
    value: n = /* @__PURE__ */ Object.create(null)
  }), n;
}
function z(e, t, n) {
  if (e[t]) return e[t];
  const [r, l] = Q(n, {
    equals: !1,
    internal: !0
  });
  return r.$ = l, e[t] = r;
}
function Lt(e, t) {
  const n = Reflect.getOwnPropertyDescriptor(e, t);
  return !n || n.get || !n.configurable || t === A || t === E || (delete n.value, delete n.writable, n.get = () => e[A][t]), n;
}
function Ie(e) {
  ce() && z(q(e, E), De)();
}
function It(e) {
  return Ie(e), Reflect.ownKeys(e);
}
const Rt = {
  get(e, t, n) {
    if (t === he) return e;
    if (t === A) return n;
    if (t === pe)
      return Ie(e), n;
    const r = q(e, E), l = r[t];
    let i = l ? l() : e[t];
    if (t === E || t === C || t === "__proto__") return i;
    if (!l) {
      const o = Object.getOwnPropertyDescriptor(e, t);
      ce() && (typeof i != "function" || e.hasOwnProperty(t)) && !(o && o.get) && (i = z(r, t, i)());
    }
    return V(i) ? Le(i) : i;
  },
  has(e, t) {
    return t === he || t === A || t === pe || t === E || t === C || t === "__proto__" ? !0 : (ce() && z(q(e, C), t)(), t in e);
  },
  set() {
    return !0;
  },
  deleteProperty() {
    return !0;
  },
  ownKeys: It,
  getOwnPropertyDescriptor: Lt
};
function W(e, t, n, r = !1) {
  if (!r && e[t] === n) return;
  const l = e[t], i = e.length;
  n === void 0 ? (delete e[t], e[C] && e[C][t] && l !== void 0 && e[C][t].$()) : (e[t] = n, e[C] && e[C][t] && l === void 0 && e[C][t].$());
  let o = q(e, E), s;
  if ((s = z(o, t, l)) && s.$(() => n), Array.isArray(e) && e.length !== i) {
    for (let c = e.length; c < i; c++) (s = o[c]) && s.$();
    (s = z(o, "length", i)) && s.$(e.length);
  }
  (s = o[De]) && s.$();
}
function Re(e, t) {
  const n = Object.keys(t);
  for (let r = 0; r < n.length; r += 1) {
    const l = n[r];
    W(e, l, t[l]);
  }
}
function zt(e, t) {
  if (typeof t == "function" && (t = t(e)), t = T(t), Array.isArray(t)) {
    if (e === t) return;
    let n = 0, r = t.length;
    for (; n < r; n++) {
      const l = t[n];
      e[n] !== l && W(e, n, l);
    }
    W(e, "length", r);
  } else Re(e, t);
}
function D(e, t, n = []) {
  let r, l = e;
  if (t.length > 1) {
    r = t.shift();
    const o = typeof r, s = Array.isArray(e);
    if (Array.isArray(r)) {
      for (let c = 0; c < r.length; c++)
        D(e, [r[c]].concat(t), n);
      return;
    } else if (s && o === "function") {
      for (let c = 0; c < e.length; c++)
        r(e[c], c) && D(e, [c].concat(t), n);
      return;
    } else if (s && o === "object") {
      const { from: c = 0, to: a = e.length - 1, by: f = 1 } = r;
      for (let h = c; h <= a; h += f)
        D(e, [h].concat(t), n);
      return;
    } else if (t.length > 1) {
      D(e[r], t, [r].concat(n));
      return;
    }
    l = e[r], n = [r].concat(n);
  }
  let i = t[0];
  typeof i == "function" && (i = i(l, n), i === l) || r === void 0 && i == null || (i = T(i), r === void 0 || V(l) && V(i) && !Array.isArray(i) ? Re(l, i) : W(e, r, i));
}
function Ut(...[e, t]) {
  const n = T(e || {}), r = Array.isArray(n), l = Le(n);
  function i(...o) {
    Ye(() => {
      r && o.length === 1 ? zt(n, o[0]) : D(n, o);
    });
  }
  return [l, i];
}
var Ft = /* @__PURE__ */ y('<svg><marker viewBox="0 0 10 10"refX=9.5 refY=5 markerWidth=4 markerHeight=5 orient=auto-start-reverse><path d="M 0 0 L 10 5 L 0 10 z"fill=var(--tc-color-accent-1)></svg>', !1, !0, !1);
function Y(e) {
  return (() => {
    var t = Ft();
    return U(t, e, !0, !0), t;
  })();
}
var Kt = /* @__PURE__ */ y("<button class=button>");
function Xt(e) {
  const [t, n] = de(e, ["children"]);
  return (() => {
    var r = Kt();
    return U(r, n, !1, !0), g(r, () => t.children), r;
  })();
}
var Bt = /* @__PURE__ */ y("<label class=input-root><span class=input-label></span><input class=input-input type=text>");
function ie(e) {
  const [t, n] = de(e, ["children", "error", "label"]);
  return (() => {
    var r = Bt(), l = r.firstChild, i = l.nextSibling;
    return g(l, () => t.label), U(i, n, !1, !1), r;
  })();
}
function ze(e) {
  return e === null || typeof e > "u";
}
function X(e, t, n, r, l) {
  return [e, t, n, r, l].some(isNaN) ? NaN : e === 1 / 0 || e === -1 / 0 ? e : (e - t) * (l - r) / (n - t) + r;
}
function L(e, t = 0, n = 1) {
  return e > n ? n : e > t ? e : t;
}
function Ht(e, t, n, r) {
  var i;
  if (!r || !n)
    return {
      x: 0,
      y: 0
    };
  r.x = e, r.y = t;
  const l = r.matrixTransform((i = n.getScreenCTM()) == null ? void 0 : i.inverse());
  return {
    x: l.x,
    y: l.y
  };
}
function se(e, t = 0, n = Math.pow(10, t)) {
  return Math.round(e * n) / n + 0;
}
const Ue = (e = "ru-RU") => (t) => new Intl.NumberFormat(e, t), Fe = Ue()({
  style: "unit",
  unit: "meter",
  unitDisplay: "short",
  minimumFractionDigits: 1,
  maximumFractionDigits: 1
}), Gt = Ue()({
  minimumFractionDigits: 1,
  maximumFractionDigits: 1
}), Ke = _e();
function Vt(e) {
  const t = () => {
    var n;
    return (n = e.sceneRef()) == null ? void 0 : n.createSVGPoint();
  };
  return p(Ke.Provider, {
    get value() {
      return {
        sceneRef: e.sceneRef,
        sceneSvgPoint: t
      };
    },
    get children() {
      return e.children;
    }
  });
}
function qt() {
  const e = Me(Ke);
  if (ze(e))
    throw new Error("useScene must be used within a SceneContext.Provider");
  return e;
}
function Wt(e) {
  const [t, n] = Ut({
    /**
     * The truck weight capacity.
     */
    weight: {
      value: e.weight ?? 2.8,
      min: e["weight-min"] ?? 2.8,
      max: e["weight-max"] ?? 96
    },
    /**
     * The truck weight height from the ground.
     */
    height: {
      value: e.height ?? 3.4,
      min: e["height-min"] ?? 3.4,
      max: e["height-max"] ?? 84
    },
    /**
     * The truck weight distance from the rotation point.
     */
    length: {
      value: e.length ?? 3.4,
      min: e["length-min"] ?? 3.4,
      max: e["length-max"] ?? 84
    },
    /**
     * The truck weight position and dimensions.
     */
    block: {
      x: 270,
      y: 325,
      width: 120,
      height: 80
    },
    /**
     * Rotation point coordinates.
     */
    rotation: {
      x: 16,
      y: 432
    },
    /**
     * Scene dimensions.
     */
    scene: {
      width: 700,
      height: 500,
      offset_x: 60,
      offset_y: 40,
      pattern_size: 20
    },
    trunk_length: 388.6,
    /**
     * Weight connector initial coordinates.
     */
    connector: {
      x: 330,
      y: 210
    },
    width_offset: 50
  }), r = () => X(t.length.value, t.length.min, t.length.max, t.connector.x, 550), l = () => X(t.height.value, t.height.min, t.height.max, 410, 310), i = () => X(t.length.value, t.length.min, t.length.max, t.connector.x, 550), o = (_, M) => {
    const F = r(), te = L(_, t.connector.x, 550), Be = X(t.height.value, t.height.min, t.height.max, 410, t.connector.y), He = L(M, t.connector.y, 410);
    n("height", "value", t.height.value * Be / He), n("length", "value", t.length.value * te / F);
  }, s = () => i() - 330, c = () => 410 - l(), a = () => {
    const _ = i() - t.rotation.x, M = t.rotation.y - t.connector.y + c();
    return Math.atan2(M, _) * 180 / Math.PI;
  }, f = () => `rotate(${-a()} ${t.rotation.x} ${t.rotation.y})`, h = () => `translate(${s()} ${-c()})`, d = () => i() - t.rotation.x, v = () => t.rotation.y - t.connector.y + c();
  return {
    model: t,
    setModel: n,
    trunkLength: () => (d() ** 2 + v() ** 2) ** 0.5,
    arrowHeightX: r,
    arrowHeightY: l,
    arrowLengthX: i,
    rotation: f,
    translate: h,
    dy: c,
    setStateFromCoords: o
  };
}
const Xe = _e();
function Yt(e) {
  const [t, n] = de(e, ["children"]), r = Wt(n);
  return p(Xe.Provider, {
    value: r,
    get children() {
      return t.children;
    }
  });
}
function S() {
  const e = Me(Xe);
  if (ze(e))
    throw new Error("useModel must be used within a ModelContext.Provider");
  return e;
}
var Jt = /* @__PURE__ */ y("<svg><g><defs></defs><path class=arrow></path><text class=scene-text font-size=16px></svg>", !1, !0, !1);
function Qt() {
  const {
    model: e,
    arrowLengthX: t,
    dy: n
  } = S(), r = k(), l = k(), i = () => e.connector.y - n(), o = () => `M0,${i() - 20} ${t()},${i() - 20}`, s = () => t() / 2, c = () => i() - 30;
  return (() => {
    var a = Jt(), f = a.firstChild, h = f.nextSibling, d = h.nextSibling;
    return g(f, p(Y, {
      id: r,
      refX: 9
    }), null), g(f, p(Y, {
      id: l,
      refX: 8
    }), null), u(h, "marker-start", `url(#${r})`), u(h, "marker-end", `url(#${l})`), g(d, () => Fe.format(e.length.value)), m((v) => {
      var x = o(), _ = s(), M = c();
      return x !== v.e && u(h, "d", v.e = x), _ !== v.t && u(d, "x", v.t = _), M !== v.a && u(d, "y", v.a = M), v;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), a;
  })();
}
var en = /* @__PURE__ */ y("<svg><g><defs></defs><path class=arrow></path><text class=scene-text font-size=16px></svg>", !1, !0, !1);
function tn() {
  const {
    model: e,
    arrowHeightX: t,
    arrowHeightY: n
  } = S(), r = k(), l = k(), i = () => `M${t()},${e.scene.height} ${t()},${n()}`, o = () => t() + 42, s = () => n() + (e.scene.height - n()) / 2;
  return (() => {
    var c = en(), a = c.firstChild, f = a.nextSibling, h = f.nextSibling;
    return g(a, p(Y, {
      id: r,
      refX: 10
    }), null), g(a, p(Y, {
      id: l,
      refX: 8
    }), null), u(f, "marker-end", `url(#${l})`), u(f, "marker-start", `url(#${r})`), g(h, () => Fe.format(e.height.value)), m((d) => {
      var v = i(), x = o(), _ = s();
      return v !== d.e && u(f, "d", d.e = v), x !== d.t && u(h, "x", d.t = x), _ !== d.a && u(h, "y", d.a = _), d;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), c;
  })();
}
var nn = /* @__PURE__ */ y("<svg><g><g class=chains><path d=M325.8,317.41c-.46-1.19.25-2.59.6-2.9,1.97-.09,5.83-2.31,5.23-3.71-.97-2.27-4.79-4.12-4.79-5.85,0-1.59.04-3.9.04-3.9h4.25v3.3c0,1.59,5.56,3.26,5.56,7.66,0,5.31-6.14,6.78-9.82,6.97-.39-.7-.79-.83-1.07-1.57Z fill=#19141e></path><path d=M329.97,301.41c-.81,0-1.63-.02-2.44.02-.23,1.15-.79,3.6.2,4.51.04-.82-.43-2.19,0-2.97.44-.81,1.53-.7,2.12-1.32 fill=var(--tc-truck-wheel-color)></path><path d=M334.59,267.81v-53.37c1.12-1.15,1.81-2.72,1.81-4.44,0-3.53-2.86-6.39-6.39-6.39s-6.39,2.86-6.39,6.39c0,1.25.37,2.42.99,3.41v54.4h-8.29v3.85l6.62,4.3h13.25l6.62-4.3v-3.85h-8.22ZM325.31,214.33c1.17,1.26,2.83,2.06,4.69,2.06,1.46,0,2.81-.5,3.89-1.33v52.74h-8.58v-53.48Z fill=#19141e></path><path d=M328.21,290.66h1.99c1.08,0,1.95.87,1.95,1.95v5.19c0,1.08-.88,1.94-1.95,1.94h-1.99c-1.07,0-1.94-.87-1.94-1.94v-5.19c0-1.07.87-1.95,1.94-1.95ZM327.73,296.94c0,.72.43,1.31.98,1.31h1c.54,0,.98-.59.98-1.31v-3.47c0-.72-.44-1.3-.98-1.3h-1c-.54,0-.98.58-.98,1.3v3.47Z fill=#19141e></path><path d=M328.21,278.67h1.99c1.08,0,1.95.87,1.95,1.95v5.19c0,1.07-.88,1.94-1.95,1.94h-1.99c-1.07,0-1.94-.87-1.94-1.94v-5.19c0-1.08.87-1.95,1.94-1.95ZM327.73,284.95c0,.72.43,1.3.98,1.3h1c.54,0,.98-.58.98-1.3v-3.47c0-.72-.44-1.3-.98-1.3h-1c-.54,0-.98.59-.98,1.3v3.47Z fill=#19141e></path><path d=M328.28,291.65c0,.51.41.93.93.93s.92-.42.92-.93v-5.44c0-.51-.41-.93-.92-.93s-.93.42-.93.93v5.44Z fill=#19141e></path><path d=M328.28,280.43c0,.51.41.92.93.92s.92-.41.92-.92v-5.44c0-.51-.41-.92-.92-.92s-.93.41-.93.92v5.44Z fill=#19141e></path><path d=M331.77,272.88c0-1.35-1.09-2.44-2.43-2.44s-2.43,1.09-2.43,2.44,1.09,2.44,2.43,2.44c1.35,0,2.43-1.09,2.43-2.44Z fill=#49434f></path><path d=M326.41,300.23c0,1.54,1.25,2.79,2.79,2.79s2.79-1.25,2.79-2.79-1.25-2.8-2.79-2.8-2.79,1.25-2.79,2.8Z fill=#19141e></path><path d=M348.97,324.42l-18.53-9.82-17.51,9.82 fill=none stroke=#000></path><circle cx=330 cy=210 r=3.71 fill=#49434f></svg>", !1, !0, !1);
function rn(e) {
  const {
    translate: t
  } = S();
  return (() => {
    var n = nn();
    return n.firstChild, g(n, () => e.children, null), m(() => u(n, "transform", t())), n;
  })();
}
var ln = /* @__PURE__ */ y('<svg><g id=rotator><polygon id=rotator-2 data-name=rotator points="38.86 423.23 47.87 423.2 36.41 403.19 36.36 403.13 16.18 423.11 23.89 430.89 36.44 418.46 38.86 423.23"fill=#1f2b5c></polygon><path d=M16.14,442.24c-5.27,0-9.55-4.28-9.55-9.55s4.28-9.55,9.55-9.55,9.55,4.28,9.55,9.55-4.28,9.55-9.55,9.55Z fill=#19141e></path><path d=M16.14,425.97c3.71,0,6.71,3.01,6.71,6.71s-3,6.71-6.71,6.71-6.72-3-6.72-6.71,3.01-6.71,6.72-6.71Z fill=var(--tc-truck-wheel-color)></path><path d=M16.14,429.29c1.88,0,3.4,1.52,3.4,3.4s-1.52,3.4-3.4,3.4-3.4-1.52-3.4-3.4,1.52-3.4,3.4-3.4Z fill=#19141e></svg>', !1, !0, !1);
function sn() {
  const {
    rotation: e
  } = S();
  return (() => {
    var t = ln();
    return m(() => u(t, "transform", e())), t;
  })();
}
var on = /* @__PURE__ */ y("<svg><g><path d=M26.08,482.96c0,9.32,7.55,16.88,16.88,16.88s16.87-7.56,16.87-16.88-7.56-16.87-16.87-16.87-16.88,7.55-16.88,16.87Z fill=var(--tc-truck-wheel-color)></path><path d=M33.49,482.96c0,5.23,4.24,9.46,9.46,9.46s9.46-4.24,9.46-9.46-4.24-9.46-9.46-9.46-9.46,4.24-9.46,9.46Z fill=#19141e></path><path d=M33.49,483.21c0,5.09,4.11,9.21,9.19,9.21s9.19-4.13,9.19-9.21-4.11-9.21-9.19-9.21c-5.08,0-9.19,4.13-9.19,9.21Z fill=var(--tc-color-accent-1)></path><path d=M39.06,482.96c0,2.15,1.74,3.89,3.89,3.89s3.89-1.74,3.89-3.89-1.74-3.89-3.89-3.89c-2.15,0-3.89,1.74-3.89,3.89Z fill=var(--tc-truck-line-pattern-color)></path><path d=M39.06,483.17c0,2.04,1.67,3.68,3.74,3.68s3.74-1.64,3.74-3.68-1.68-3.68-3.74-3.68c-2.07,0-3.74,1.65-3.74,3.68Z fill=var(--tc-truck-line-pattern-color)></path><path d=M39.87,483.2c0,1.65,4.74-3.01,3.06-3.01s-3.06,1.35-3.06,3.01Z fill=#dcdcdc></path><path d=M42.06,475.33c0,.39.31.7.7.7s.7-.31.7-.7-.31-.71-.7-.71-.7.32-.7.71ZM42.06,491.41c0,.39.31.7.7.7s.7-.32.7-.7-.31-.71-.7-.71-.7.32-.7.71ZM50.12,484.07c0,.39.32.7.71.7s.7-.31.7-.7-.31-.71-.7-.71-.71.32-.71.71ZM34.08,482.96c0,.39.31.7.71.7s.7-.31.7-.7-.31-.7-.7-.7-.71.32-.71.7ZM36.52,477.4c0,.39.32.71.7.71s.71-.32.71-.71-.32-.7-.71-.7-.7.32-.7.7ZM47.36,488.98c0,.39.31.7.7.7s.71-.32.71-.7-.32-.71-.71-.71-.7.32-.7.71ZM47.7,478.11c0,.39.32.7.7.7s.71-.32.71-.7-.31-.71-.71-.71-.7.31-.7.71ZM36.34,488.47c0,.39.32.7.7.7s.7-.32.7-.7-.32-.71-.7-.71-.7.32-.7.71Z fill=#af752a></path><path d=M42.06,475.42c0,.34.27.61.61.61s.61-.27.61-.61-.27-.6-.61-.6c-.34,0-.61.27-.61.6ZM42.06,491.5c0,.34.27.61.61.61s.61-.27.61-.61-.27-.61-.61-.61-.61.27-.61.61ZM50.12,484.17c0,.33.28.6.62.6s.62-.27.62-.6-.28-.61-.62-.61-.62.27-.62.61ZM34.08,483.06c0,.33.27.6.62.6s.61-.27.61-.6-.27-.61-.61-.61-.62.27-.62.61ZM36.52,477.5c0,.33.27.61.62.61s.61-.27.61-.61-.27-.61-.61-.61-.62.27-.62.61ZM47.36,489.07c0,.34.27.61.61.61s.62-.27.62-.61-.27-.6-.62-.6c-.34,0-.61.27-.61.6ZM47.7,478.21c0,.33.27.61.61.61s.62-.27.62-.61-.28-.61-.62-.61-.61.27-.61.61ZM36.34,488.57c0,.33.28.61.61.61s.62-.27.62-.61-.28-.61-.62-.61c-.34,0-.61.27-.61.61Z fill=var(--tc-truck-line-pattern-color)></svg>", !1, !0, !1), cn = /* @__PURE__ */ y("<svg><g id=wheels><use x=35 y=0></use><use x=165 y=0></use><use x=200 y=0></svg>", !1, !0, !1);
function an(e) {
  return (() => {
    var t = on();
    return U(t, e, !0, !0), t;
  })();
}
function un() {
  const e = k();
  return (() => {
    var t = cn(), n = t.firstChild, r = n.nextSibling, l = r.nextSibling;
    return g(t, p(an, {
      id: e
    }), n), u(n, "href", `#${e}`), u(r, "href", `#${e}`), u(l, "href", `#${e}`), t;
  })();
}
var fn = /* @__PURE__ */ y("<svg><g id=truck><path d=M93.38,468.78h83.76v11.41h-94.62s-15.91,0-15.91,0h0s-39.45,0-39.45,0l-3.39,2.07h-2.2l.34-18.31h39.88s27.74-.16,27.74-.16l3.86,4.99ZM262.43,465.17h-38.65v-.57l-27.53-.16-7.15,9.25v4.01l1.29,3.03h30.04v.57h39.16l3.36,2.05-.52-18.17Z fill=#19141e></path><path d=M3.15,451.8l47.84,5.25v-25.02H3.15v19.78Z fill=var(--tc-color-accent-1)></path><path d=M.32,427.43h51.81v4.59H.32v-4.59Z fill=#1f2b5c></path><path d=M130.52,447.06h8.62v10.39h-8.62v-10.39Z fill=var(--tc-color-accent-1)></path><path d=M130.52,447.06h4.82v10.39h-4.82v-10.39Z fill=#1f2b5c></path><path d=M33.63,454.5h107v5.88H33.63v-5.88Z fill=#1f2b5c></path><path d=M137.58,439.91h-5.28l-2.32,8.12h9.7l-2.09-8.12Z fill=#4d75ba></path><path d=M132.92,440.59h3.77l2.37,7.44-3.72-5.92-2.41-1.52Z fill=#799dd2></path><path d=M90.88,468.78h91.35v-8.83h-94.48l3.14,8.83Z fill=var(--tc-truck-wheel-color)></path><path d=M141.09,479.76c0,.59.44,1.08.97,1.08h27.82c.53,0,.97-.48.97-1.08v-8.87c0-.6-.44-1.08-.97-1.08h-27.82c-.54,0-.97.48-.97,1.08v8.87Z fill=var(--tc-truck-wheel-color)></path><path d=M145.97,480.84c0,.25.2.44.44.44s.44-.2.44-.44v-11.03c0-.25-.2-.44-.44-.44s-.44.2-.44.44v11.03Z fill=#47414d></path><path d=M153.78,471.79c0,.26.21.47.47.47h3.43c.26,0,.47-.21.47-.47s-.21-.47-.47-.47h-3.43c-.26,0-.47.21-.47.47Z fill=#635b69></path><path d=M104.19,479.86c0,.59.44,1.08.98,1.08h27.82c.54,0,.98-.48.98-1.08v-8.87c0-.6-.44-1.08-.98-1.08h-27.82c-.54,0-.98.48-.98,1.08v8.87Z fill=var(--tc-truck-wheel-color)></path><path d=M128,480.94c0,.24.2.44.44.44s.44-.2.44-.44v-11.03c0-.24-.2-.44-.44-.44s-.44.2-.44.44v11.03Z fill=#47414d></path><path d=M109.07,480.94c0,.24.2.44.44.44s.44-.2.44-.44v-11.03c0-.24-.2-.44-.44-.44s-.44.2-.44.44v11.03Z fill=#47414d></path><path d=M116.89,471.89c0,.26.21.47.47.47h3.43c.26,0,.47-.21.47-.47s-.21-.47-.47-.47h-3.43c-.26,0-.47.21-.47.47Z fill=#635b69></path><path d=M22.45,482.26l11.67-17.02h54.22l8.41,11.78,3.2-4.97-8.84-12.22H18.01v22.43h4.44Z fill=var(--tc-color-accent-3)></path><path d=M21.39,471.38c0,3.2-1.4,6.19-2.53,6.19s-.9-2.6-.9-5.8-.3-5.96.82-5.96c1.11,0,2.61,2.37,2.61,5.57Z fill=#d96d27></path><path d=M20.35,471.33c0,2.58-.91,5.11-1.39,5.11-1.43,0-2.59-2.09-2.59-4.68s1.16-4.68,2.59-4.68c.48,0,1.39,1.66,1.39,4.24Z fill=#ee2f35></path><path d=M16.78,471.32c0-1.99.9-3.61,2-3.61.2,0,.51.4.74,1.1.19.55-2.74,4.5-2.74,2.51Z fill=#f04e3f></path><path d=M122.72,454.93H50.66v-40.97h52.99l19.08,29.07v11.91Z fill=var(--tc-color-accent-1)></path><path d=M57.3,413.95c-1.41,4.13-2.06,8.57-2.09,13.02-.05,7.73.06,15.54,7.91,19.19,9.95,4.63,20.5,7.04,31.47,6.31,8.83-.59,19.22-3.69,28.12-1.51v3.97H50.66v-40.98h6.65Z fill=var(--tc-color-accent-3)></path><path d=M83.4,439.05h31.75l-12.93-20.99h-18.82v20.99Z fill=#223267></path><path d=M83.98,437.96h29.87l-12.16-19.9h-17.71v19.9Z fill=#9fb5db></path><path d=M220.6,473.52h8.1v-9.83h-8.1v9.83ZM227.18,472.01h-5.07v-6.81h5.07v6.81Z fill=#635b69></path><path d=M221.35,469.31h6.58v1.51h-6.58v-1.51Z fill=#635b69></path><path d=M221.35,466.3h6.58v1.51h-6.58v-1.51Z fill=#635b69></path><path d=M194.62,419.15c0-3.37,1.63-5.5,4.37-5.5h57.84c2.66,0,3.77,2.48,3.77,7.98v14.55c0,2.76-1.64,2.66-1.64,2.66,0,0,2.84.31,2.92,2.9.07,2.6.81,28.1.81,28.1l-4.31.61-4.38-9.78h-59.37v-41.52Z fill=var(--tc-color-accent-1)></path><path d=M198.99,413.65h6.55c-10.64,10.44-16.07,28.27-1.37,37.75,17.68,11.4,39.24,1.19,58.18,6.67.18,6.2.33,11.77.33,11.77l-4.31.61-4.38-9.78h-59.37v-41.52c0-3.37,1.63-5.5,4.37-5.5Z fill=var(--tc-color-accent-3)></path><path d=M245.67,435.19c0,.94.76,1.7,1.71,1.7h7.99c.94,0,1.7-.76,1.7-1.7v-16.96c0-.94-.76-1.71-1.7-1.71h-7.99c-.95,0-1.71.77-1.71,1.71v16.96Z fill=#223267></path><path d=M218.16,435.19c0,.94.77,1.7,1.71,1.7h20.06c.94,0,1.71-.76,1.71-1.7v-16.96c0-.94-.76-1.71-1.71-1.71h-20.06c-.94,0-1.71.77-1.71,1.71v16.96Z fill=#223267></path><path d=M245.97,434.3c0,.9.74,1.62,1.66,1.62h7.79c.92,0,1.66-.73,1.66-1.62v-16.15c0-.9-.74-1.63-1.66-1.63h-7.79c-.92,0-1.66.73-1.66,1.63v16.15Z fill=#9fb5db></path><path d=M219.18,434.3c0,.9.74,1.62,1.66,1.62h19.54c.92,0,1.66-.73,1.66-1.62v-16.15c0-.9-.74-1.63-1.66-1.63h-19.54c-.92,0-1.66.73-1.66,1.63v16.15Z fill=#9fb5db></path><path d=M213.36,415.25h.71v45.43h-.71v-45.43Z fill=#fff></path><path d=M218.16,440.83c0,.51.41.92.92.92h5.24c.51,0,.92-.41.92-.92s-.41-.92-.92-.92h-5.24c-.51,0-.92.41-.92.92Z fill=#2f1413></path><path id=lines d=M201.13,420.27h6.84c.25,0,.45.2.45.44s-.2.44-.45.44h-6.84c-.25,0-.44-.2-.44-.44s.19-.44.44-.44ZM200.68,423.11c0,.24.19.45.44.45h6.84c.25,0,.45-.2.45-.45s-.2-.44-.45-.44h-6.84c-.25,0-.44.2-.44.44ZM200.68,425.51c0,.25.19.44.44.44h6.84c.25,0,.45-.2.45-.44s-.2-.44-.45-.44h-6.84c-.25,0-.44.2-.44.44ZM200.68,427.91c0,.24.19.44.44.44h6.84c.25,0,.45-.2.45-.44s-.2-.45-.45-.45h-6.84c-.25,0-.44.2-.44.45ZM200.68,430.31c0,.24.19.44.44.44h6.84c.25,0,.45-.2.45-.44s-.2-.45-.45-.45h-6.84c-.25,0-.44.2-.44.45ZM200.68,432.71c0,.24.19.44.44.44h6.84c.25,0,.45-.2.45-.44s-.2-.44-.45-.44h-6.84c-.25,0-.44.2-.44.44ZM57.04,420.72c0,.24.2.44.44.44h6.85c.25,0,.44-.2.44-.44s-.2-.44-.44-.44h-6.85c-.25,0-.44.2-.44.44ZM57.04,423.11c0,.24.2.45.44.45h6.85c.25,0,.44-.2.44-.45s-.2-.44-.44-.44h-6.85c-.25,0-.44.2-.44.44ZM57.04,425.51c0,.25.2.44.44.44h6.85c.25,0,.44-.2.44-.44s-.2-.44-.44-.44h-6.85c-.25,0-.44.2-.44.44ZM57.04,427.91c0,.24.2.44.44.44h6.85c.25,0,.44-.2.44-.44s-.2-.45-.44-.45h-6.85c-.25,0-.44.2-.44.45ZM57.04,430.31c0,.24.2.44.44.44h6.85c.25,0,.44-.2.44-.44s-.2-.45-.44-.45h-6.85c-.25,0-.44.2-.44.45ZM57.04,432.71c0,.24.2.44.44.44h6.85c.25,0,.44-.2.44-.44s-.2-.44-.44-.44h-6.85c-.25,0-.44.2-.44.44Z fill=var(--tc-truck-line-pattern-color)></path><path d=M260.16,462.96c0,2.71,1.2,5.25,2.14,5.25s.77-2.2.77-4.92.26-5.06-.69-5.06-2.22,2.01-2.22,4.73Z fill=#d96d27></path><path d=M261.04,462.92c0,2.2.77,4.35,1.17,4.35,1.21,0,2.2-1.78,2.2-3.97s-.98-3.97-2.2-3.97c-.4,0-1.17,1.41-1.17,3.6Z fill=#ee2f35></path><path d=M264.07,462.91c0-1.69-.76-3.06-1.7-3.06-.17,0-.44.34-.64.94-.16.47,2.33,3.82,2.33,2.13Z fill=#f04e3f></path><path d=M261.34,445.58h1.9v12.26h-1.9v-12.26Z fill=var(--tc-truck-wheel-color)></path><path d=M185.65,481.2l11.92-15.8h55.37l10.01,17.93,1.49.25.13-13.13-4.41-1.8-4.39-8.93h-74.65v21.47h4.53Z fill=var(--tc-color-accent-3)></path><path d=M263.1,471.66h.97v10.67h-.97v-10.67Z fill=var(--tc-color-accent-1)></path><path d=M181.89,460.67h67.95v.46h-67.95v-.46Z fill=var(--tc-color-accent-1)></path><path d=M250.94,427.36c-1.78-.9-3.44-1.89-4.96-2.94v-6.27c0-.9.74-1.63,1.66-1.63h7.79c.92,0,1.66.73,1.66,1.63v11.7c-2.01-.63-4.08-1.45-6.14-2.49Z fill=#c6d5ee></path><path d=M220.84,416.53h19.54c.92,0,1.66.73,1.66,1.63v10.36c-4.25-.05-9.45-1.37-14.64-3.97-3.16-1.59-5.95-3.47-8.23-5.46v-.93c0-.9.74-1.62,1.66-1.62Z fill=#c6d5ee></path><path d=M108.68,429.51c-4.08-.2-8.95-1.5-13.8-3.93-3.16-1.59-11.19-7.23-10.9-7.52h17.71l6.99,11.45Z fill=#c6d5ee></path><path d=M229.46,414.52s28.83-1.44,29.59.73c1.44,4.11.76,21.65.76,21.65,0,0-.52-17.19-2.73-20.37-1.55-2.23-27.62-2.01-27.62-2.01Z fill=var(--tc-color-accent-3)></path><path d=M74.71,415s28.61-1.35,29.59.73c1.09,2.33,11.45,18.59,11.45,18.59,0,0-10.13-14.62-12.34-17.79-1.55-2.23-28.7-1.53-28.7-1.53Z fill=var(--tc-color-accent-3)></svg>", !1, !0, !1);
function hn() {
  return fn();
}
var dn = /* @__PURE__ */ y('<svg><g><defs><clipPath><rect x=199.79 y=444.06 width=9 height=11.03 fill=none></rect></clipPath><linearGradient x1=205.9 y1=1585.66 x2=198.8 y2=1577.4 gradientTransform="translate(4 2034.02) scale(1 -1)"gradientUnits=userSpaceOnUse><stop offset=0 stop-color=#676867></stop><stop offset=1 stop-color=#f4f4f5></stop></linearGradient><linearGradient x1=202.5 y1=1589.79 x2=192.45 y2=1576.08 gradientTransform="translate(4 2034.02) scale(1 -1)"gradientUnits=userSpaceOnUse><stop offset=0 stop-color=#f4f4f5></stop><stop offset=1 stop-color=#676867></stop></linearGradient><linearGradient x1=202.21 y1=1582.02 x2=201.37 y2=1577.3></linearGradient><linearGradient x1=198.74 y1=1582.02 x2=197.74 y2=1577.26></linearGradient></defs><g><g><path d=M206.04,447.46l-.88,1.08.36,4.33,3.27,2.18-2.75-7.59Z></path><path d=M204.77,443.97l-4.99,11.13h0s2.15-2.63,2.15-2.63l3.22-3.94.88-1.08-1.26-3.48Z></path><path d=M205.52,452.86l-.58-.39-2.13,1.08,2.82.7,3.15.78-3.27-2.18Z></path><path d=M201.93,452.47l-2.15,2.63,3.02-1.54,2.13-1.08h-3.01Z></svg>', !1, !0, !1);
function gn(e) {
  const t = k(), n = k(), r = k(), l = k(), i = k();
  return (() => {
    var o = dn(), s = o.firstChild, c = s.firstChild, a = c.nextSibling, f = a.nextSibling, h = f.nextSibling, d = h.nextSibling, v = s.nextSibling, x = v.firstChild, _ = x.firstChild, M = _.nextSibling, F = M.nextSibling, te = F.nextSibling;
    return U(o, e, !0, !0), u(c, "id", t), u(a, "id", n), u(f, "id", r), u(h, "id", l), u(h, "href", `#${r}`), u(d, "id", i), u(d, "href", `#${r}`), u(x, "clip-path", `url(#${t})`), u(_, "fill", `url(#${n})`), u(M, "fill", `url(#${r})`), u(F, "fill", `url(#${l})`), u(te, "fill", `url(#${i})`), o;
  })();
}
var pn = /* @__PURE__ */ y("<svg><g><defs><pattern patternUnits=userSpaceOnUse><rect class=scene-pattern x=0 y=0></rect></pattern></defs><rect></svg>", !1, !0, !1);
function vn() {
	const { model: e } = S(), t = k();
	return (() => {
		var n = pn(), r = n.firstChild, i = r.firstChild, l = i.firstChild, c = r.nextSibling;

		u(i, "id", t);
		u(c, "fill", "rgba(173,216,230,0.1)"); // нежно-голубой прозрачный фон
		u(i, "patternUnits", "userSpaceOnUse");
		u(i, "patternContentUnits", "userSpaceOnUse");
		u(i, "viewBox", `0 0 ${e.scene.pattern_size} ${e.scene.pattern_size}`);
		u(i, "width", e.scene.pattern_size);
		u(i, "height", e.scene.pattern_size);
		u(l, "class", "scene-pattern");
		u(l, "width", e.scene.pattern_size);
		u(l, "height", e.scene.pattern_size);

		m(() => {
			const svg = document.querySelector("svg.scene");
			if (!svg) return;
			const w = e.scene.width;
			const h = e.scene.height;
			u(c, "x", -e.scene.offset_x);
			u(c, "y", e.scene.offset_y);
			u(c, "width", w);
			u(c, "height", h);
			u(c, "stroke", "rgba(173,216,230,0.2)");
			u(c, "stroke-width", 1);
		});

		return n;
	})();
}
var bn = /* @__PURE__ */ y("<svg><g><line class=scene-axis></line><line class=scene-axis x1=0 x2=0></svg>", !1, !0, !1);
function yn() {
  const {
    model: e
  } = S();
  return (() => {
    var t = bn(), n = t.firstChild, r = n.nextSibling;
    return m((l) => {
      var i = -e.scene.offset_x, o = e.scene.width, s = e.scene.height, c = e.scene.height, a = e.scene.offset_y, f = e.scene.height + e.scene.offset_y;
      return i !== l.e && u(n, "x1", l.e = i), o !== l.t && u(n, "x2", l.t = o), s !== l.a && u(n, "y1", l.a = s), c !== l.o && u(n, "y2", l.o = c), a !== l.i && u(r, "y1", l.i = a), f !== l.n && u(r, "y2", l.n = f), l;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0,
      n: void 0
    }), t;
  })();
}
var wn = /* @__PURE__ */ y('<svg><polygon points="330 220.87 341.94 203.42 318.06 203.42 330 220.87"fill=var(--tc-color-accent-1)></svg>', !1, !0, !1), mn = /* @__PURE__ */ y('<svg><g class=trunk><rect x=365.05 y=425.8 height=9.04 fill=var(--tc-color-accent-1)></rect><rect x=167.76 y=424.82 width=197.31 height=10.98 fill=var(--tc-color-accent-1)></rect><path d=M275.01,424.85v10.95h-107.23l-.04-10.98,107.27.03Z fill=var(--tc-color-accent-1)></path><g id=trunk-1><path d=M167.66,422.87l.04,15.15-151.56,1.38v-16.1s151.52-.43,151.52-.43Z fill=var(--tc-color-accent-1)></path><polygon points="167.79 438.68 167.74 421.93 163.61 421.94 163.64 432.83 95.23 433.02 95.24 435.55 163.65 435.35 163.66 438.69 167.79 438.68"fill=#4570b7></polygon></g><circle id=target-1-2 data-name=target-1 cx=16.18 cy=432.69 r=1.83 fill=#ed2024></circle><polygon points="365.07 437.23 365.03 423.39 361.98 423.4 362 432.08 294.41 432.27 294.42 434.8 362.01 434.61 362.02 437.24 365.07 437.23"fill=#4570b7></svg>', !1, !0, !1);
function xn() {
  const {
    translate: e
  } = S();
  return (() => {
    var t = wn();
    return m(() => u(t, "transform", e())), t;
  })();
}
function $n() {
  const {
    rotation: e,
    trunkLength: t,
    model: n
  } = S(), r = 37.75, l = () => t() - n.trunk_length;
  return [(() => {
    var i = mn(), o = i.firstChild;
    return m((s) => {
      var c = e(), a = r + l();
      return c !== s.e && u(i, "transform", s.e = c), a !== s.t && u(o, "width", s.t = a), s;
    }, {
      e: void 0,
      t: void 0
    }), i;
  })(), p(xn, {})];
}
var _n = /* @__PURE__ */ y("<svg><rect class=weight rx=4 ry=4></svg>", !1, !0, !1), Mn = /* @__PURE__ */ y('<svg><text class="scene-text weight-text"> т</svg>', !1, !0, !1);
function kn() {
  const {
    setStateFromCoords: e
  } = S(), {
    sceneRef: t,
    sceneSvgPoint: n
  } = qt(), r = () => {
    window.addEventListener("pointerup", i, {
      once: !0
    }), window.addEventListener("pointermove", l);
  }, l = (o) => {
    const s = t(), c = n();
    if (!s || !c)
      return;
    const a = Ht(o.clientX, o.clientY, s, c);
    e(a.x, a.y);
  }, i = () => {
    window.removeEventListener("pointermove", l);
  };
  return Je(() => {
    window.removeEventListener("pointerup", i), window.removeEventListener("pointermove", l);
  }), {
    handlePointerDown: r
  };
}
function Sn() {
  const {
    model: e
  } = S(), t = kn();
  return [(() => {
    var n = _n();
    return Te(n, "pointerdown", t.handlePointerDown, !0), m((r) => {
      var l = e.block.x, i = e.block.y, o = e.block.width, s = e.block.height;
      return l !== r.e && u(n, "x", r.e = l), i !== r.t && u(n, "y", r.t = i), o !== r.a && u(n, "width", r.a = o), s !== r.o && u(n, "height", r.o = s), r;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0
    }), n;
  })(), (() => {
    var n = Mn(), r = n.firstChild;
    return g(n, () => Gt.format(e.weight.value), r), m((l) => {
      var i = e.block.x + e.block.width / 2, o = e.block.y + e.block.height / 2;
      return i !== l.e && u(n, "x", l.e = i), o !== l.t && u(n, "y", l.t = o), l;
    }, {
      e: void 0,
      t: void 0
    }), n;
  })()];
}
Ee(["pointerdown"]);
var An = /* @__PURE__ */ y("<form class=form>");
function Cn() {
  const {
    model: e,
    setModel: t
  } = S(), [n, r] = Q(null), l = (i) => {
    var f;
    i.preventDefault();
    const {
      length: o,
      height: s,
      weight: c
    } = T(e), a = new CustomEvent("formsubmit", {
      bubbles: !0,
      composed: !0,
      detail: {
        length: o.value,
        height: s.value,
        weight: c.value
      }
    });
    (f = n()) == null || f.dispatchEvent(a);
  };
  return (() => {
    var i = An();
    return ge(r, i), i.addEventListener("submit", l), g(i, p(ie, {
      label: "Вес груза, т:",
      type: "number",
      get min() {
        return e.weight.min;
      },
      get max() {
        return e.weight.max;
      },
      step: "0.1",
      required: !0,
      get value() {
        return se(e.weight.value, 1);
      },
      onChange: (o) => t("weight", "value", L(o.target.valueAsNumber, e.weight.min, e.weight.max))
    }), null), g(i, p(ie, {
      label: "Высота подъёма, м:",
      type: "number",
      get min() {
        return e.height.min;
      },
      get max() {
        return e.height.max;
      },
      step: "0.1",
      required: !0,
      get value() {
        return se(e.height.value, 1);
      },
      onChange: (o) => t("height", "value", L(o.target.valueAsNumber, e.height.min, e.height.max))
    }), null), g(i, p(ie, {
      label: "Вылет, м:",
      type: "number",
      get min() {
        return e.length.min;
      },
      get max() {
        return e.length.max;
      },
      step: "0.1",
      required: !0,
      get value() {
        return se(e.length.value, 1);
      },
      onChange: (o) => t("length", "value", L(o.target.valueAsNumber, e.height.min, e.height.max))
    }), null), g(i, p(Xt, {
      type: "submit",
      children: "Подобрать"
    }), null), i;
  })();
}
var Zn = /* @__PURE__ */ y("<svg class=scene>");
function On(e) {
  const {
    model: t
  } = S(), [n, r] = Q(), l = () => `${-t.scene.offset_x} ${t.scene.offset_y} ${t.scene.width} ${t.scene.height}`;
  return p(Vt, {
    sceneRef: n,
    get children() {
      var i = Zn();
      return ge(r, i), g(i, p(vn, {}), null), g(i, p(yn, {}), null), g(i, p(tn, {}), null), g(i, p(Qt, {}), null), g(i, () => e.children, null), m(() => u(i, "viewBox", l())), i;
    }
  });
}
var Pn = /* @__PURE__ */ y("<svg><g><use x=-143 y=-3.5></svg>", !1, !0, !1);
function En() {
  const e = k();
  return (() => {
    var t = Pn(), n = t.firstChild;
    return g(t, p($n, {}), n), g(t, p(hn, {}), n), g(t, p(sn, {}), n), g(t, p(un, {}), n), g(t, p(rn, {
      get children() {
        return p(Sn, {});
      }
    }), n), g(t, p(gn, {
      id: e
    }), n), u(n, "href", `#${e}`), t;
  })();
}
const Tn = ".app-container *{padding:0;margin:0;box-sizing:border-box}.app-container{--tc-color-accent-1:hsl(218 71% 33%);--tc-color-accent-2:hsl(218 63% 41%);--tc-color-accent-3:hsl(218 55% 45%);--tc-color-text:hsl(0 0% 15%);--tc-color-border:hsl(0 0% 78%);--tc-color-danger:red;--tc-scale:var(--tc-unit,10px);--tc-truck-weight-color:rgb(28 70 143 / 10%);--tc-truck-line-pattern-color:white;--tc-truck-wheel-color:hsl(267 10% 18%);font-size:10px;font-family:var(--tc-font,monospace);display:flex;width:100%}.calculator .container{max-width:100%;width:100%;padding:0}.app{display:flex;flex-direction:column;align-items:stretch;width:100%;gap:clamp(16px,2vw,32px)}@media (min-width:480px){.app{flex-direction:row;align-items:stretch;height:auto}}.form{display:grid;grid-template:repeat(4,min-content)/1fr;gap:calc(2 * var(--tc-scale));height:341px}@media (max-width:479px){.form,.scene{width:100%;height:auto;}}@media (min-width:480px){.form{width:40%}.scene{width:60%}}.scene{border:1px solid var(--tc-color-border);border-radius:calc(.5 * var(--tc-scale));display:flex;align-items:center;justify-content:center;background-color:white;background-image:linear-gradient(to right, rgba(173, 216, 230, 0.4) 1px, transparent 1px),linear-gradient(to bottom, rgba(173, 216, 230, 0.4) 1px, transparent 1px);background-size:20px 20px;height:341px;padding:0}.scene svg{width:100%;height:auto;display:block}.button{display:inline-flex;justify-content:center;align-items:center;gap:var(--tc-scale);width:100%;height:auto;padding:calc(2 * var(--tc-scale));border-radius:calc(.5 * var(--tc-scale));background-color:var(--tc-color-accent-1);color:#fff;font-size:calc(1.6 * var(--tc-scale));font-family:inherit;outline:none;border:none;cursor:pointer;transition:background-color .15s linear,outline 125ms ease-in-out,transform .125s ease-in-out}.button:hover{background-color:var(--tc-color-accent-2)}.button:is(:active,:hover:active,:focus-visible){background-color:var(--tc-color-accent-3)}.button:focus-visible{outline:2px solid var(--tc-color-accent-3);outline-offset:2px}.button:active{transform:translateY(1px)}.input-root{display:grid;gap:calc(.5 * var(--tc-scale));text-align:left;font-size:var(--font-size-2);width:100%}.input-label{width:fit-content;font-size:calc(1.4 * var(--tc-scale))}.input-input{background-color:var(--color-surface-1);border:2px solid var(--tc-color-border);border-radius:calc(.5 * var(--tc-scale));padding:calc(1.4 * var(--tc-scale)) calc(2 * var(--tc-scale));color:var(--tc-color-text);width:100%;font-family:inherit;font-weight:600;font-size:calc(1.6 * var(--tc-scale));transition:outline-color .125s linear;outline:3px solid transparent;outline-offset:-3px}.input-input:focus-visible{outline-color:var(--tc-color-accent-1)}.input-input:user-invalid{outline-color:var(--tc-color-danger)}.input-input::-webkit-inner-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0}.input-input[type=number]{-moz-appearance:textfield;-webkit-appearance:textfield;appearance:textfield}.scene-pattern{stroke:var(--tc-color-border);opacity:.5;fill:none}.scene:has(.weight:active){cursor:move;outline:2px solid var(--tc-color-accent-3)}.scene-text{font-variant-numeric:tabular-nums;text-anchor:middle;dominant-baseline:middle;-webkit-user-select:none;user-select:none;pointer-events:none;user-drag:none;-webkit-user-drag:none;fill:var(--tc-color-accent-1)}.weight{fill:var(--tc-truck-weight-color);stroke:var(--tc-color-accent-1);stroke-width:2;cursor:grab;transition:filter .125s ease-in-out}.weight:active{cursor:move;stroke:var(--tc-color-accent-3);filter:drop-shadow(0 0 3px var(--tc-color-accent-3))}.weight[data-dragged]{cursor:move}.weight-text{font-size:calc(2 * var(--tc-scale))}.arrow{stroke-width:2;fill:none;stroke:var(--tc-color-accent-1)}.scene-axis{stroke:black;stroke-width:1}";
var Nn = /* @__PURE__ */ y("<style>"), jn = /* @__PURE__ */ y("<div class=app-container><div class=app>");
function Dn(e) {
  return [(() => {
    var t = Nn();
    return g(t, Tn), t;
  })(), p(Yt, it(e, {
    get children() {
      var t = jn(), n = t.firstChild;
      return g(n, p(Cn, {}), null), g(n, p(On, {
        get children() {
          return p(En, {});
        }
      }), null), t;
    }
  }))];
}
function Ln() {
  return {
    "weight-min": 2.8,
    weight: 2.8,
    "weight-max": 96,
    "length-min": 3.4,
    length: 3.4,
    "length-max": 84,
    "height-min": 3.4,
    height: 3.4,
    "height-max": 84
  };
}
function In() {
  Dt("truck-calculator", Ln(), (e) => p(Dn, e));
}
In();
export { In as TruckCalculator }; 